"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgMoneyCheck32 = function SvgMoneyCheck32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.738.604c-.937-.685-1.913-.721-2.716-.436a3.563 3.563 0 00-1.6 1.183l-9.723 12.946c-2.173 2.894-3.323 6.402-3.673 8.055a.967.967 0 00.096.696 1.009 1.009 0 00.904.514H26c.552 0 1-.442 1-.987a.993.993 0 00-1-.986h-8.466c1.363-.953 2.857-2.205 4.016-3.748l9.722-12.946a3.49 3.49 0 00.681-1.855c.042-.841-.277-1.751-1.215-2.436zm-2.71 1.92c.13-.172.386-.4.67-.5.223-.079.49-.098.85.165s.42.52.408.754a1.54 1.54 0 01-.29.777l-9.723 12.947c-1.204 1.603-2.857 2.873-4.273 3.787.559-1.521 1.426-3.37 2.636-4.983L28.03 2.525z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M1 6.794c-.552 0-1 .442-1 .986v19.234C0 27.558.448 28 1 28h30c.552 0 1-.442 1-.986V15.178a.993.993 0 00-1-.987c-.552 0-1 .442-1 .987v10.85H2V8.766h16c.552 0 1-.442 1-.987a.993.993 0 00-1-.986H1z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M5 12.712a.993.993 0 011-.986h7.643c.552 0 1 .441 1 .986a.993.993 0 01-1 .986H6c-.552 0-1-.441-1-.986zM5 16.657a.993.993 0 011-.986h4c.552 0 1 .442 1 .986a.993.993 0 01-1 .986H6c-.552 0-1-.441-1-.986z",
    fill: "currentColor"
  }));
};

SvgMoneyCheck32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgMoneyCheck32;
exports.default = _default;